import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  SwipeableDrawer,
  Typography,
  styled,
  useMediaQuery,
} from '@mui/material';
import {
  ElementType,
  FC,
  Fragment,
  SyntheticEvent,
  useEffect,
  useState,
} from 'react';
import { Link } from 'react-router-dom';

import { useActions } from '../../../hooks/useActions';
import { useMain } from '../../../hooks/useMain';
import { useUser } from '../../../hooks/useUser';
import { ICatalog } from '../../../shared/types/main-catalog';

import './Menu.sass';

// Кастомный стиль
const CssSwipeableDrawer = styled(SwipeableDrawer)({
  '& .MuiDrawer-paper': {
    width: '100%',
    top: 120,
    padding: '0 16px',
    backgroundColor: '#F6F8FB',
    borderRight: 0,
    borderTop: 0,
    boxShadow: 'none',
  },
  '& .MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 40,
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: 0,
  },
  '& .MuiBackdrop-root': { top: 120, backgroundColor: 'transparent' },
});
const CssAccordion = styled(Accordion)({
  '&.MuiAccordion-root': {
    borderRadius: '8px',
    boxShadow: '0px 2px 2px rgb(0 0 0 / 8%)',
  },
  '&.MuiBackdrop-root': {
    top: 100,
  },
  '&:before': {
    display: 'none',
  },
});
const FireNav = styled(List)<{ component?: ElementType }>({
  '& .MuiListItemButton-root': {
    paddingLeft: 24,
    paddingRight: 24,
  },
  '& .MuiListItemIcon-root': {
    minWidth: 0,
    marginRight: 16,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
});

interface ICustomMenuProps {
  openCategory: string;
  catalog?: boolean;
}

export const CustomMenu: FC<ICustomMenuProps> = ({ catalog }) => {
  const { setMenuVisible } = useActions();
  const { visibleMenuDialog, openMobileCategory } = useUser();
  const { processes, materials, equipments, services, articles, loading } =
    useMain();
  const openMenuDialog = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuVisible(true);
  };
  const closeMenuDialog = () => setMenuVisible(false);
  const toggleMenuDialog = () => setMenuVisible(!visibleMenuDialog);
  const mobileScreen = useMediaQuery('(max-width:900px)');
  const [expanded, setExpanded] = useState<string | false>('panel1');
  const [content, setContent] = useState<ICatalog>({} as ICatalog);

  const data = Object.entries(content);
  const handleChange =
    (panel: string) => (event: SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  useEffect(() => {
    setContent({ processes, materials, equipments });
  }, [processes, materials, equipments]);
  useEffect(() => {
    setMenuVisible(false);
  }, []);

  return (
    <>
      <CssSwipeableDrawer
        anchor="bottom"
        open={visibleMenuDialog}
        onClose={closeMenuDialog}
        onOpen={openMenuDialog}
        variant="temporary"
        ModalProps={{
          keepMounted: false,
        }}
        sx={{
          '& .MuiDrawer-paperAnchorBottom': {
            marginBottom: '56px',
          },
        }}
      >
        {/*<Header hide="processes" />*/}
        {catalog && (
          <div className="mobile-menu__title" onClick={closeMenuDialog}>
            <ArrowBackIosNewRoundedIcon />
            <h1>Фильтры</h1>
          </div>
        )}

        {catalog ? (
          data.map((elem, index) => {
            return (
              <div
                key={`${elem}_${index}`}
                role="presentation"
                className="mobile-menu-top"
              >
                <List
                  className="mobile-menu-top__wrapper"
                  onClick={closeMenuDialog}
                >
                  {mobileScreen ? <></> : <ArrowBackIosNewRoundedIcon />}
                  <h2 className="mobile-menu-top__title">
                    {elem[0] === 'processes' && 'Процессы'}
                    {elem[0] === 'materials' && 'Материалы'}
                    {elem[0] === 'equipments' && 'Оборудование'}
                  </h2>
                </List>
                <List>
                  <div className="mobile-menu-accordion__list">
                    {!loading && elem ? (
                      elem[1].map((item: any) => {
                        return (
                          <CssAccordion
                            key={`${item.id}_${index}`}
                            expanded={
                              item.children.length !== 0
                                ? expanded === item.id
                                : false
                            }
                            onChange={handleChange(item.id)}
                          >
                            {item.children.length !== 0 ? (
                              <AccordionSummary
                                expandIcon={
                                  expanded === item.id ? (
                                    <RemoveRoundedIcon />
                                  ) : (
                                    <AddRoundedIcon />
                                  )
                                }
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <Typography>{item.title}</Typography>
                              </AccordionSummary>
                            ) : (
                              <Link
                                to={`/${
                                  elem[0] === 'processes'
                                    ? 'process'
                                    : elem[0] === 'materials'
                                    ? 'material'
                                    : 'equipment'
                                }/${item.slug}`}
                                onClick={closeMenuDialog}
                              >
                                <AccordionSummary
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                >
                                  <Typography>{item.title}</Typography>
                                </AccordionSummary>
                              </Link>
                            )}

                            <AccordionDetails sx={{ padding: 0 }}>
                              <FireNav sx={{ padding: 0 }}>
                                {item.children.map((children: any) => {
                                  return (
                                    <ListItem
                                      key={`${children.id}_${index}`}
                                      sx={{ padding: '0 16px' }}
                                    >
                                      <Link
                                        to={`/${elem[0]}/${children.slug}`}
                                        onClick={closeMenuDialog}
                                      >
                                        <ListItemText
                                          primary={children.title}
                                        />
                                      </Link>
                                    </ListItem>
                                  );
                                })}
                              </FireNav>
                            </AccordionDetails>
                          </CssAccordion>
                        );
                      })
                    ) : (
                      <Fragment>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={50}
                          sx={{ borderRadius: '8px' }}
                        />
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={50}
                          sx={{ borderRadius: '8px' }}
                        />
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={50}
                          sx={{ borderRadius: '8px' }}
                        />
                      </Fragment>
                    )}
                  </div>
                </List>
              </div>
            );
          })
        ) : (
          <div role="presentation">
            <List
              className="mobile-menu-top__wrapper"
              onClick={closeMenuDialog}
            >
              <ArrowBackIosNewRoundedIcon />
              <h2 className="mobile-menu-top__title">
                {openMobileCategory === 'materials' && 'Материалы'}
                {openMobileCategory === 'equipments' && 'Оборудования'}
              </h2>
            </List>
            <List>
              <div className="mobile-menu-accordion__list">
                {
                  // @ts-ignore
                  content[openMobileCategory] &&
                    // @ts-ignore
                    content[openMobileCategory].map((item: any) => {
                      return (
                        <CssAccordion
                          key={`${item.id}`}
                          expanded={
                            item.children.length !== 0
                              ? expanded === item.id
                              : false
                          }
                          onChange={handleChange(item.id)}
                        >
                          {item.children.length !== 0 ? (
                            <AccordionSummary
                              expandIcon={
                                expanded === item.id ? (
                                  <RemoveRoundedIcon />
                                ) : (
                                  <AddRoundedIcon />
                                )
                              }
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography>{item.title}</Typography>
                            </AccordionSummary>
                          ) : (
                            <Link
                              to={`/${openMobileCategory}/${item.slug}`}
                              onClick={closeMenuDialog}
                            >
                              <AccordionSummary
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <Typography>{item.title}</Typography>
                              </AccordionSummary>
                            </Link>
                          )}

                          {item.children.length !== 0 && (
                            <AccordionDetails sx={{ padding: 0 }}>
                              <FireNav sx={{ padding: 0 }}>
                                {item.children.map(
                                  (children: any, index: number) => {
                                    return (
                                      <ListItem
                                        key={`${children.id}_${index}`}
                                        sx={{ padding: '0 16px' }}
                                      >
                                        <Link
                                          to={`/${openMobileCategory}/${children.slug}`}
                                          onClick={closeMenuDialog}
                                        >
                                          <ListItemText
                                            primary={children.title}
                                          />
                                        </Link>
                                      </ListItem>
                                    );
                                  }
                                )}
                              </FireNav>
                            </AccordionDetails>
                          )}
                        </CssAccordion>
                      );
                    })
                }
              </div>
            </List>
          </div>
        )}
      </CssSwipeableDrawer>
    </>
  );
};
